<template>
    <div id="main" :class="[ navIsVisible ? 'expand-main' : 'closed-main' ]">
      <div id="filterButton">
        <span
          :class="isScrolling ? 'hide-btn' : ''"
          @click.prevent="toggleNav">

          {{ !navIsVisible ? 'Show Filters' : 'Hide Filters' }}
        </span>
      </div>

      <div class="sidenav" :style="'top:' + setTop" :class="[ navIsVisible ? 'expand-sidenav' : 'closed-sidenav' ]">

        <aside>
          <div class="sidebar-group" :style="styles">

            <transition name="fade" mode="out-in">
              <div class="fixed filter-heading" :class="!navIsVisible ? 'filter-controls' : ''">
                <span>Filters</span>
                <button class="close closebtn" @click="toggleNav">x</button>
              </div>
            </transition>

            <transition name="fade" mode="out-in">
              <filters-sidebar-section class="sidebar-spacing" :class="!navIsVisible ? 'fade-sidebar-content' : ''" v-show="displayFilterOptions">
                <search-products />
                <sort-products />
                <color-filters />
                <br>
                <item-filters />
              </filters-sidebar-section>
            </transition>

            <a href="/shop/powder-coating-collections" id="collection-btn" class="btn btn-default btn-block">View Collections</a>

            <filters-sidebar-section no-padding :sticky-offset="400" :style="!displayFilterOptions ? 'top: 50px;' : ''">
              <filter-options />
            </filters-sidebar-section>

            <transition-group name="fade" mode="out-in">
              <div class="fixed filter-footer" :class="!navIsVisible ? 'filter-controls' : ''" :key="1">
                <button class="btn btn-blue btn-block" @click.prevent="applyFilterOptions" key="save">Apply Filters</button>
                <button class="btn btn-black btn-block" @click="reset" key="reset">
                  <i class="fa fa-undo" aria-hidden="true"></i>
                  Reset Filters
                </button>
              </div>
            </transition-group>

          </div>
        </aside>
      </div>
    </div>
</template>

<script>
  import SearchProducts from "./filters/SearchCoatingsProducts";
  import SortProducts from "./filters/SortProducts";
  import colorFilters from './filters/ColorFilters';
  import itemFilters from './filters/ItemFilters';
  import filterOptions from './filters/FilterOptions';
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import FiltersSidebarSection from "./FiltersSidebarSection";
  import SecondaryNavigation from "./SecondaryNavigation";

  export default {
    name: 'filters-sidebar',

    components: {
      SecondaryNavigation,
      FiltersSidebarSection,
      SearchProducts,
      SortProducts,
      colorFilters,
      filterOptions,
      itemFilters
    },

    data() {
      return {
        navIsVisible: true,
        setTop: '',
        styles: {
          height: `${$(window).height() - 180}px`,
        },
        scrollPos: window.scrollY,
        isScrolling: false
      }
    },

    computed: {
      ...mapGetters([
        'searchText',
        'currentShopPage',
        'navBar',
        'selectedCollectionCategory',
        'selectedFilterOptions',
        'allParentFilters',
      ]),

      hasSelectedParentCollection() {
        const parentCollection = this.selectedCollectionCategory.parent_category_refs;

        if(parentCollection.length && parentCollection[0].name === 'Collections') {
          return true;
        }

        return false;
      },

      activeSubCollections() {
        const parentCategory = this.selectedCollectionCategory.parent_category_refs;
        const subCategory = this.selectedCollectionCategory.sub_categories;

        if(parentCategory.length) {
          return parentCategory[0].name === 'Collections' ? subCategory.filter((active) => {
            return active.enabled;
          }) : [];
        }

        return [];
      },

      displayFilterOptions() {
        if (this.hasSelectedParentCollection && this.activeSubCollections.length) return false;
        else if (this.hasSelectedParentCollection && !this.activeSubCollections.length) return true;
        return true;
      },
    },

    watch: {
      scrollPos() {
      var timer = null;

      window.addEventListener('scroll', () => {
        this.isScrolling = true;

        if(timer !== null) {
          clearTimeout(timer);
        }

        timer = window.setTimeout(() => {
          this.isScrolling = false;
        }, 500);
      });
      },

      $mq() {
        if(this.$mq !== 'desktop') {
          this.setTop = '0px';

          return;
        }

        this.setTop = '149px';
      }
    },

    created() {
      if(screen.width <= 1070) {
        this.navIsVisible = false;
        this.setNavBar(this.navIsVisible);
      }
    },

    mounted() {
      $(window).on('resize', () => {
        this.styles.height = `${$(window).height() - 180}px`;
      });

      window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
      ...mapActions([
        'resetFilters',
        'renderProducts',
        'toggleFilterOption'
      ]),

      ...mapMutations([
        'setNavBar'
      ]),

      reset() {
        this.selectedFilterOptions.forEach(filter => {
          let clickedFilter = filter;
          let filterParent = null;

          for (let ref of filter.parent_category_refs) {
            filterParent = this.allParentFilters.find(filter => filter.id.toString() === ref.id.toString());
            if (filterParent) break;
          }

          this.toggleFilterOption({ clickedFilter, filterParent });
        })

        this.resetFilters();
      },

      applyFilterOptions() {
        this.renderProducts();
        this.navIsVisible = !this.navIsVisible;
        this.setNavBar(this.navIsVisible);
      },

      toggleNav() {
        this.navIsVisible = !this.navIsVisible;
        this.setNavBar(this.navIsVisible);
      },

      handleScroll() {
        this.scrollPos = window.scrollY;
      }
    }
  }
</script>

<style lang="scss" scoped>
  #main {
    transition: margin-left 0.1s;
  }

  #filterButton {
    width: 0;
    left: auto;
    position: fixed;
    top: 50%;
    z-index: 98;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    cursor: pointer;
    padding-top: 40px;

    .hide-btn {
      transition: opacity 0.1s;
      opacity: 0;
      pointer-events: none;
    }

    span {
      display: block;
      background-color: #3982c4;
      height: 40px;
      width: 140px;
      padding: 8px 16px 10px;
      color: #fff;
      font-size: 17px;
      font-weight: 600;
      text-decoration: none;
      border-radius:0 0 6px 6px;
      text-align: center;
      transition: opacity 0.1s;
      opacity: 1;
    }
  }

  .expand-sidenav {
    width: 320px;
  }

  .closed-sidenav {
    width: 0;
  }

  .expand-main {
    margin-left: 320px;
  }

  .fade-sidebar-content {
    transition: opacity 0.1s;
    opacity: 0 !important;
  }

  .closed-main {
    margin-left: 0;


    .filter-controls {
      width: 0 !important;
      padding: 0 !important;
      position: absolute;

      .btn {
        transition: opacity 0.1s;
        opacity: 0;
        position: absolute;
      }
    }
  }

  #collection-btn {
    color: #393939;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 11px 20px 10px 20px;
  }

  .sidebar-spacing {
    transition: opacity 0.1s;
    opacity: 1;
  }

  .sidenav {
    height: 100%;
    position: fixed;
    z-index: 98;
    left: 0;
    background-color:#fff;
    overflow-x: hidden;
    transition: 0.1s;
    top: 149px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    a {
      text-decoration: none;
      font-size: 25px;
      color: #818181;
      display: block;
      transition: 0.1s;
    }

    a:hover {
      color: #f1f1f1;
    }
  }

  .fixed {
    position: fixed;
    left: 0;
    background-color: #f7f7f7;
    width: 320px;
    transition: 0.1s;
    z-index: 1;
  }

  .filter-heading {
    box-shadow: 0 1px 3px rgba(0,0,0,.10);
    border-bottom: 1px solid #ddd;

    span {
      position: absolute;
      padding: 10px;
      font-size: 18px;
      font-weight: 600;
    }

    .closebtn {
      font-size: 30px;
      padding: 8px 12px;
    }
  }

  .filter-footer {
    bottom: 0%;
    padding: 10px;
    border-top: 1px solid #ddd;
    box-shadow: 0 -1px 3px rgba(0,0,0,.10);

    .btn {
      transition: opacity 0.1s;
      opacity: 1;
    }
  }

  aside {
    padding: 0;
    width: 20%;
    min-width: 320px;
    max-width: 320px;

    ::-webkit-scrollbar {
      display:none;
    }

    .sidebar-group {
      position: sticky;
      top: 149px;
      overflow: hidden scroll;
      padding: 0 10px;

      &.no-stick {
        position: initial;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent;
      }

      &::-webkit-scrollbar {
        border-radius: 10px;
        width: 6px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #c1c1c1;;
      }
    }
  }

  @media screen and (max-width: 1070px) {
    .sidenav {
      z-index: 201;
    }

    aside {
      width: 100%;
      min-width: inherit;
      max-width: inherit;
    }

    .filter-heading {
      top: 0;
      width: 100%;
    }

    .filter-footer {
      width: 100%;
    }

    .expand-sidenav {
      width: 100%
    }

    .hide-mobile {
      display: none;
    }
  }

  @media screen and (max-width: 510px) {
    aside {
      width: auto;
      border-radius: 0;
      max-width: inherit;

      .sidebar-group {
        position: initial;
        height: auto !important;
        overflow: unset;
      }
    }

    .sidenav .closebtn {
      top: 8px;
    }
  }

  @media screen and (max-width: 480px) {
    .sidenav {
      padding-bottom: 60px;
      }

    .sidenav a {font-size: 18px;}
  }
</style>
